import { useState, useEffect } from 'react';
import addDays from '../../node_modules/date-fns/esm/addDays/index.js';
import isSameDay from '../../node_modules/date-fns/esm/isSameDay/index.js';

var useDateRangePicker = function useDateRangePicker(config) {
  var _config$departureDate, _config$returnDate, _config$departureDate2, _config$returnDate2;

  if (config === void 0) {
    config = {};
  }

  // Internal state
  var _useState = useState((_config$departureDate = config.departureDate) != null ? _config$departureDate : addDays(new Date(), 1)),
      _departureDate = _useState[0],
      _setDepartureDate = _useState[1];

  var _useState2 = useState((_config$returnDate = config.returnDate) != null ? _config$returnDate : addDays(new Date(), 8)),
      _returnDate = _useState2[0],
      _setReturnDate = _useState2[1]; // Exposed state


  var _useState3 = useState((_config$departureDate2 = config.departureDate) != null ? _config$departureDate2 : addDays(new Date(), 1)),
      departureDate = _useState3[0],
      setDepartureDate = _useState3[1];

  var _useState4 = useState((_config$returnDate2 = config.returnDate) != null ? _config$returnDate2 : addDays(new Date(), 8)),
      returnDate = _useState4[0],
      setReturnDate = _useState4[1];

  var _useState5 = useState(false),
      isResettable = _useState5[0],
      setIsResettable = _useState5[1];

  var _useState6 = useState(false),
      showCalendar = _useState6[0],
      setShowCalendar = _useState6[1];

  var _useState7 = useState(true),
      isStartDateSelected = _useState7[0],
      setIsStartDateSelected = _useState7[1];

  var openCalendar = function openCalendar(selectStartDateByDefault) {
    if (selectStartDateByDefault === void 0) {
      selectStartDateByDefault = true;
    }

    setIsStartDateSelected(selectStartDateByDefault);
    setShowCalendar(true);
  };

  var handleDateChange = function handleDateChange() {
    if (!departureDate && !returnDate) return;

    _setDepartureDate(departureDate);

    _setReturnDate(returnDate);

    config.handleDateChange(departureDate, returnDate);
    setShowCalendar(false);
  };

  var resetDateRange = function resetDateRange() {
    setDepartureDate(_departureDate);
    setReturnDate(_returnDate);
  };

  useEffect(function () {
    setIsResettable(!(isSameDay(_departureDate, departureDate) && isSameDay(_returnDate, returnDate)));
  }, [_departureDate, departureDate, _returnDate, returnDate]);
  return {
    openCalendar: openCalendar,
    showCalendar: showCalendar,
    setShowCalendar: setShowCalendar,
    departureDate: departureDate,
    setDepartureDate: setDepartureDate,
    returnDate: returnDate,
    setReturnDate: setReturnDate,
    resetDateRange: resetDateRange,
    isStartDateSelected: isStartDateSelected,
    setIsStartDateSelected: setIsStartDateSelected,
    isResettable: isResettable,
    handleDateChange: handleDateChange
  };
}; // eslint-disable-next-line import/prefer-default-export

export { useDateRangePicker };
//# sourceMappingURL=useDateRangePicker.js.map
